// extracted by mini-css-extract-plugin
export default {"rowWrapper":"quote-inco-term_rowWrapper__zqEPB","rowWrapperHalf":"quote-inco-term_rowWrapperHalf__lid5t"};